import { useEffect } from "react";

export const usePageTitle = (pageTitle: string) => {
  useEffect(() => {
    document.title = `D2D - ${pageTitle}`;
  }, [pageTitle]);
};
